(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement{
    connectedCallback(){
      this.header=document.querySelector('.section-header');
      this.headerIsAlwaysSticky=this.dataset.stickyType==='always'||this.dataset.stickyType==='reduce-logo-size';
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change',()=>this.setHeaderHeight());
      if(this.headerIsAlwaysSticky)this.header.classList.add('shopify-section-header-sticky');
      this.onScrollHandler=this.onScroll.bind(this);
      window.addEventListener('scroll',this.onScrollHandler);
    }
    setHeaderHeight(){document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`)}
    onScroll(){
      const scrollTop=window.pageYOffset;
      if(scrollTop>this.header.offsetHeight)this.header.classList.add('scrolled-past-header');
      else this.header.classList.remove('scrolled-past-header');
    }
  }
  customElements.define('sticky-header',StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
